<style lang="less">
</style>

<template>
  <el-card>
    <div slot="header"></div>
    <div class="form-container">
      <el-form
        ref="ruleForm"
        :model="form"
        :rules="rules"
        label-width="135px"
        v-loading="loading"
      >
        <el-form-item label="说明书名称" prop="name">
          <el-input v-model="form.name" placeholder="说明书名称" />
        </el-form-item>
        <el-form-item label="说明书类型" prop="type" style="width: 100%">
          <el-radio-group v-model="form.type">
            <el-radio :label="item.value" name="type" v-for="(item, index) in $enums.instructionsStatus.getList()"
                         :key="index">{{item.label}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="产品分类" prop="cateId">
          <el-select v-model="form.cateId" placeholder="请选择">
            <el-option :label="item.name" :value="item.id" v-for="(item, index) in cates" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="说明书商品">
            <el-input type="textarea" v-model="form.productName"></el-input>
            <div>多个内容请以逗号(,)分隔</div>
        </el-form-item>

        <el-form-item label="说明书文件" prop="path">
          <el-upload
            :action="uploadPath"
            :auto-upload="true"
            :headers="uploadHeaders"
            :data="uploadPdfParam"
            :accept="pdfAccept"
            :beforeUpload="beforePdfUpload"
            :on-success="handleIconUrlSuccess"
            :on-remove="handleIconUrlRemove"
            :on-error="handleIconUrlError"
            :limit="1"
            :file-list="iconUrlList"
          >
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">提交</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- <ec-instructions-product-select ref="productselect" @submit="productSubmit" :type="form.type" :instructionId="id"></ec-instructions-product-select> -->
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </el-card>
</template>

<script>
import _ from "lodash";
import formMixin from "@/mixin/form";

export default {
  mixins: [formMixin],
  data() {
    return {
      id: null,
      loading: false,
      form: {
        name: "",
        path: "",
        productName: '',
        products: [],
        cateId:undefined,
      },
      rules: {
        name: this.$formHelper.requiredRuleFactory("请填写说明书名称"),
        // productName: this.$formHelper.requiredRuleFactory("请填写说明书商品"),
        path: [{ required: true, message: "请上传说明书文件", trigger: "blur" }],
        type: [{ required: true, message: "请选择说明书类型", trigger: "blur" }],
      },

      dialogVisible: false,
      dialogImageUrl: "",
      iconUrlList: [],
    };
  },

  methods: {
    removeProduct(item) {
        const index = _.findIndex(this.form.products, product => {
            return product.productId == item.productId
        })
        if (index >= 0) {
            const form = _.cloneDeep(this.form)
            form.products.splice(index, 1)
            this.form = form
        }
    },
    productSubmit(rows) {
        const form = _.cloneDeep(this.form)
        for (let i = 0; i < rows.length; i++) {
          rows[i].productId = rows[i].id
          delete rows[i].id
        }
        form.products = _.uniqBy([...form.products, ...rows], p => p.productId)
        this.form = form
    },
    showProductSelect() {
        this.$refs.productselect && this.$refs.productselect.show()
    },
tableHeaderStyle() {
      return "color:#000;font-wight:500;font-size:16px;height:60px;background-color:#e6e9f2;";
    },
    async init() {
      const queryParam = {
        query: {},
        pagination: {limit: 20}
      }
      const {collection} = await this.$store.dispatch('productCates/collection', queryParam)
      this.cates = collection

      const { id } = this.$route.query;
      if (id) {
        this.id = id;
        const { document } = await this.$store.dispatch(
          "instructions/document",
          id,
        );
        // if (document.products && document.products.length) {
        //   for (let i = 0; i < document.products.length; i++) {
        //     const product = document.products[i]
        //     document.products[i] = {
        //       ...product,
        //       name: product && product.product && product.product.name ? product.product.name : '',
        //       price: product && product.product && product.product.price ? product.product.price : '',
        //       mainFileUrl: product && product.product && product.product.mainFileUrl ? product.product.mainFileUrl : '',
        //       productId: product && product.product && product.product.id ? product.product.id : '',
        //     }
        //   }
        // }
        // this.form = _.cloneDeep({ products: [], ...document});
        if (document.products && document.products.length) {
          const productNames = []
          document.products.map(item => {
            if (item.productName) {
              productNames.push(item.productName)
            }
          })
          document.productName = productNames.join(',')
        } else {
          document.productName = ''
        }

        this.form = { ...document }
        this.form.cateId = +this.form.cateId 
        if (document.path) {
          this.iconUrlList = [{ url: document.fullPath, name: document.path }];
        }
      }
    },

    imagePreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleIconUrlSuccess({ data = {} } = {}, file) {
      this.iconUrlList.push(file);
      this.form.path = data.url ;
      this.loading = false;
    },
    handleIconUrlRemove() {
      this.iconUrlList = [];
      this.form.path = "";
      this.loading = false
    },
    handleIconUrlError(res) {
      let message = "上传失败";
      if (res && res.message) {
        try {
          message = JSON.parse(res.message).message;
        } catch (err) {}
      }
      this.$message.error(message);
      this.loading = false;
    },

    async onSubmit() {
      try {
        await new Promise((resovle, reject) => {
          this.$refs["ruleForm"].validate((valid) => {
            valid ? resovle(true) : reject(false);
          });
        });
      } catch (e) {
        return false;
      }

      try {
        let form = {
          name: this.form.name,
          path: this.form.path,
          type: this.form.type,
          cateId: this.form.cateId
        };
        // let products = []
        // this.form.products.forEach(item => {
        //     const product = {
        //       productId: item.productId
        //     }
        //     if (item.id) {
        //       product.id = item.id
        //     }
        //     if (this.id) {
        //       product.instructionId = this.id
        //     }
        //     products.push({ ...product})
        // })
        // form.products = products
        if (this.form.productName) {

          const productNames = this.form.productName.split(',')
          const products = []
          productNames.map(item => {
            if (item) {
              const sale = products.find(saleProduct => {
                return saleProduct.productName == item
              })
              if (!sale) {
                let oldId = ''
                if (this.form.products && this.form.products.length) {
                  const product = this.form.products.find(product => {
                    return product.productName == item
                  })
                  if (product && product.id) {
                    oldId = product.id
                  }
                }

                if (oldId) {
                  products.push({ productName: item, instructionId: this.id, id: oldId })
                } else {
                  products.push({ productName: item, instructionId: this.id })
                }
              }

            }
          })
          form.products = products
        }

        try {
          this.loading = true;
        if (this.id) {
          form.id = this.id
          await this.$store.dispatch("instructions/replace", form);
          this.$message.success("编辑成功");
        } else {
          await this.$store.dispatch("instructions/create", form);
          this.$message.success("添加成功");
        }
        this.loading = false;
        this.$router.push("/product/instructions-list");
        } catch(error) {
          this.loading = false
        }

      } catch (error) {
        this.$message.error(error.response.data.message);
        this.loading = false
      }
    },
  },
  async mounted() {
    await this.init();
  },
};
</script>
